import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/home/HeroSection';
import { PartnersSection } from '../components/home/PartnersSection';
import { WhatWeDoSection } from '../components/home/WhatWeDoSection';
import { TestimonialSection } from '../components/home/TestimonialSection';
import { AboutFounderSection } from '../components/home/AboutFounderSection';
import { Footer } from '../components/ui/Footer';
import { LoadingScreen } from '../components/ui/LoadingScreen';
export function HomePage() {
  const [isLoading, setIsLoading] = useState(true);
  const handleVideoLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };
  return <div className="bg-black" data-id="element-308">
      <LoadingScreen isLoading={isLoading} data-id="element-309" />
      <Header data-id="element-310" />
      <HeroSection onVideoLoad={handleVideoLoad} data-id="element-311" />
      <PartnersSection data-id="element-312" />
      <WhatWeDoSection data-id="element-313" />
      <TestimonialSection data-id="element-314" />
      <AboutFounderSection data-id="element-315" />
      <Footer data-id="element-316" />
    </div>;
}